import { useEffect, useState } from 'react';
import { PageSmallLoader } from '../../../component/PageLoader';
import { getIcon } from '../utils';
import { fetchDashboardCardData } from '../../../services/dashboard';
import tradeUpIcon from '../../../assets/image/ic-trending-up.svg';
import { addDays } from 'date-fns';

const SummaryCard = ({ card, isCustomizing, handleRemoveCard, filter }) => {
	const { title, icon, layout_card_id } = card;
	const [data, setData] = useState();
	const [isLoading, setLoading] = useState(false);

	const handleFetchSummaryCardData = async () => {
		try {
			setLoading(true);
			const data = await fetchDashboardCardData(layout_card_id, {
				filter_by: filter.filter_by,
				start_date:
					filter.start_date !== null ? addDays(new Date(filter.start_date), 1).toISOString() : '',
				end_date:
					filter.end_date !== null ? addDays(new Date(filter.end_date), 1).toISOString() : '',
			});
			setData(data[layout_card_id]);
		} catch (error) {
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (filter.filter_by === 'custom_date' && !filter.start_date && !filter.end_date) return;
		handleFetchSummaryCardData();
	}, [filter]);

	return (
		<div>
			{isLoading ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ minHeight: '100px' }}
				>
					<PageSmallLoader />
				</div>
			) : (
				<div
					className="d-flex justify-content-between p-3"
					style={{ flexDirection: 'column', minHeight: '100px', position: 'relative' }}
				>
					{isCustomizing && (
						<div
							style={{
								position: 'absolute',
								top: -10,
								right: -10,
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								width: '20px',
								height: '20px',
								backgroundColor: 'red',
								borderRadius: '50%',
								cursor: 'pointer',
								zIndex: 100,
							}}
							onClick={(e) => {
								handleRemoveCard(layout_card_id, e);
							}}
						>
							<div
								style={{
									color: '#000',
									fontSize: '16px',
									fontWeight: '600',
									lineHeight: '1',
									paddingBottom: '5px',
								}}
							>
								−
							</div>
						</div>
					)}
					<div className="d-flex items-start flex-1 justify-content-between">
						<div className="flex-1">
							<div className="fs-4 text-semibold text-secondary">{title}</div>
							{layout_card_id === 'setup_guide' ? (
								<div className="lead text-dark">
									<p>
										<small>Step-by-step guide to</small>
										<br />
										<small> full system setup</small>
									</p>
								</div>
							) : (
								<div className="fs-4 font-semibold text-dark">
									{['total_revenue', 'total_expenses'].includes(layout_card_id) ? `₹ ` : ''}
									{data?.total}
								</div>
							)}
						</div>
						<div className="ml-4 p-2">
							<img
								src={getIcon(icon)}
								alt=""
								width={40}
								height={40}
							/>
						</div>
					</div>
					{/* {metrics?.show && ( */}
					{layout_card_id === 'setup_guide' ? (
						<div
							className="text-bold fs-6 cursor-pointer text-primary"
							onClick={() => {}}
						>
							View Guide
						</div>
					) : (
						<div className="mt-1 d-flex items-start gap-2">
							{/* {metrics.isPositive ? ( */}
							<img
								src={tradeUpIcon}
								alt=""
							/>
							{/* ) : (
							<img
								src={tradeDownIcon}
								alt=""
							/>
						)} */}
							<span className={`fs-6 font-medium ${'text-green'}`}>{'30%'}</span>
							<span className="fs-6 text-gray-500 ml-1"> {`(${'30 days'})`}</span>
						</div>
					)}
					{/* )} */}
				</div>
			)}
		</div>
	);
};
export default SummaryCard;
